<template>
	<v-card class="mx-auto my-4 rounded-xl" width="260" height="369" elevation="24">
		<div class="tituloCardApresentacao">
			<v-card-title class="tituloCardApresentacao-numero" :class="item.cor">
				{{ item.numero }}
			</v-card-title>
			<div class="tituloCardApresentacao-descricao">
				{{ item.descricao }}
			</div>
		</div>
		<v-img :aspect-ratio="4 / 3" height="270"  class="imagemProduto" :src="require(`../../assets/${item.imagem}`)"/>
	</v-card>
</template>

<script>
export default {
	props: { item: {} },
}
</script>

<style>
.tituloCardApresentacao {
	display: flex;
	align-items: center;
	padding: 10px 20px 0 20px;
	height: 100px;
}
.tituloCardApresentacao-numero {
	padding: 0;
	font-size: 90px;
	font-weight: 700;
	display: inline;
}
.tituloCardApresentacao-descricao {
	padding-left: 10px;
	display: inline;
}
.cinzaEscuro {
	color: #464646;
}
.vermelho {
	color: #cc2128;
}
.vermelhoEscuro {
	color: #922125;
}
</style>